export const SOURCE_USERGENERATED = 'USER_GENERATED';
export const SOURCE_AI = 'CHATGPT';
export const SOURCE_CALAIS = 'CALAIS';
export const RESTRICTION_DIMENSIONS = ['GeoRestrictionDMA', 'GeoRestrictionCountry'];
export const SYSTEM_DIMENSIONS = [
    'Franchise',
    'SectionName',
    'PropertyName',
    'Source',
    'DMA',
    'Domain',
    'SectionUrl',
    'Section',
];
export const MAJOR_STORY_DIMENSION = 'Display';
export const MAJOR_STORY_NAME = 'Major Story';
export const AI_DIMENSION = 'AI Generated';